module.exports = __webpack_public_path__ + "static/media/globe.f369de6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/globe.svg
// module id = 497
// module chunks = 0